import React from 'react';
import { Loader } from 'react-feather';

/** The one spinner these pages use. */
export default function EtlLoading({ children = 'Loading…' }) {
  return (
    <div className="ep-loading" role="status">
      <Loader size={22} className="ep-spin" />
      <span>{children}</span>
    </div>
  );
}

/** Determinate progress bar (uploads, dataset refreshes). */
export function EtlProgress({ value = 0, total = 100, label }) {
  const pct = total > 0 ? Math.min(100, Math.max(0, Math.round((value / total) * 100))) : 0;
  return (
    <div className="ep-progress" role="progressbar" aria-valuemin={0} aria-valuemax={total} aria-valuenow={value}>
      <div className="ep-progress-track">
        <div className="ep-progress-fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="ep-progress-label">{label != null ? label : `${pct}%`}</div>
    </div>
  );
}
